import { defineComponent as c, computed as r, createElementBlock as s, openBlock as n, createVNode as p, Transition as d, withCtx as u, createCommentVNode as m, mergeProps as f, renderSlot as v } from "vue";
import { tw as e } from "../../utils/tailwind.js";
const b = { "aria-live": "polite" }, _ = /* @__PURE__ */ c({
  name: "RevStickyBar",
  inheritAttrs: !1,
  __name: "StickyBar",
  props: {
    position: { default: "bottom" },
    visible: { type: Boolean, default: !0 },
    snapToViewPort: { type: Boolean, default: !0 }
  },
  setup(i) {
    const t = i, l = r(() => [
      e`bg-surface-default-low border-static-default-low inset-x-0 z-10 border-solid px-24`,
      {
        top: e`top-0 border-b pb-12 pt-[calc(0.75rem+env(safe-area-inset-top))]`,
        bottom: e`bottom-0 border-t pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-12`
      }[t.position],
      t.snapToViewPort && e`fixed`
    ]), a = r(() => ({
      top: e`-translate-y-full`,
      bottom: e`translate-y-full`
    })[t.position]);
    return (o, y) => (n(), s("div", b, [
      p(d, {
        "enter-active-class": "transition duration-300 ease-in motion-reduce:transition-none",
        "enter-from-class": a.value,
        "enter-to-class": "translate-y-0",
        "leave-active-class": "transition duration-300 ease-out motion-reduce:transition-none",
        "leave-to-class": a.value
      }, {
        default: u(() => [
          o.visible ? (n(), s("div", f({ key: 0 }, o.$attrs, { class: l.value }), [
            v(o.$slots, "default")
          ], 16)) : m("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ]));
  }
});
export {
  _ as default
};
